import React from 'react'

export default ({ suggestionText, term }) => {
  // when there's no match term
  if (!term || suggestionText.indexOf(term) < 0) {
    return <span>{suggestionText}</span>
  }

  if (suggestionText === term) {
    return <strong>{term}</strong>
  }

  const splittedByTerm = suggestionText.split(term)
  const splittedByTermLength = splittedByTerm.length
  return (
    <span>
      {splittedByTerm.map((match, index) => {
        if (index < splittedByTermLength - 1) {
          return (
            <span key={index}>
              {match}{' '}
              <strong data-test-selector="highlightedTerm">{term}</strong>
            </span>
          )
        } else {
          return <span key={index}>{match}</span>
        }
      })}
    </span>
  )
}
